<!-- I18nFormItem.vue -->
<template>
  <el-form-item v-bind="finalProps">
    <!-- 默认插槽透传 -->
    <slot></slot>
    <!-- 具名插槽也透传（如 error、label 等） -->
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name"></slot>
    </template>
  </el-form-item>
</template>

<script>
export default {
  name: 'I18nFormItem',
  inheritAttrs: false,
  computed: {
    finalProps() {
      const attrs = { ...this.$attrs };

      // 如果 label 存在且是字符串，自动翻译
      if ('label' in attrs && typeof attrs.label === 'string') {
        attrs.label = this.$t(attrs.label);
      }

      return attrs;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/I18n/I18nFormItem.vue